import { gql, useFragment } from "@apollo/client";

// Constants
import {
  heroBlock,
  textImageBlock,
  postsDisplayBlock,
  contentBlock,
  galleryBlock,
  gravityFormBlock,
  accordionBlock,
} from "@/constants/constants";

// Modules
import Hero from "@/modules/hero/hero";
import TextAndImage from "@/modules/text-and-image/text-and-image";
import PostsDisplay from "@/modules/posts-display/posts-display";
import Content from "@/modules/content/content";
import Gallery from "@/modules/gallery/gallery";
import GravityFormModule from "@/modules/gravity-form/gravity-form-module";
import Accordion from "@/modules/accordion/accordion";

const blocks = {
  [heroBlock]: Hero,
  [textImageBlock]: TextAndImage,
  [postsDisplayBlock]: PostsDisplay,
  [contentBlock]: Content,
  [galleryBlock]: Gallery,
  [gravityFormBlock]: GravityFormModule,
  [accordionBlock]: Accordion,
};

export default function Modules({ id }) {
  // Use Fragment
  const { complete, data } = useFragment({
    fragment: Modules.fragments.data,
    fragmentName: "ModulesFragment",
    from: {
      __typename: "Page", //modules.__typename,
      id: id,
    },
  });
  if (!complete) {
    return;
  }

  return (
    <div className="modulesWrapper">
      {data.modules.module.map((module, i) => {
        const ModuleType = blocks[module.__typename];

        if (ModuleType) {
          return <ModuleType key={i} id={i} module={module} />;
        }
      })}
    </div>
  );
}

Modules.fragments = {
  data: gql`
    fragment ModulesFragment on Page {
      modules {
        module {
          ...HeroFragment @unmask(mode: "migrate")
          ...TextImageFragment @unmask(mode: "migrate")
          # ...PostsDisplayFragment @unmask(mode: "migrate")
          ...ContentFragment @unmask(mode: "migrate")
          ...GalleryFragment @unmask(mode: "migrate")
          ...GravityFormFragment @unmask(mode: "migrate")
          ...AccordionFragment @unmask(mode: "migrate")
        }
      }
    }
    ${Hero.fragments.module}
    ${TextAndImage.fragments.module}
    ${Content.fragments.module}
    ${Gallery.fragments.module}
    ${Accordion.fragments.module}
    ${GravityFormModule.fragments.module}
  `,
  // ${PostsDisplay.fragments.module}
};
